// import React from "react";
// import BarcodeCard from "./barcodeCard";

// export default function Page(props) {
//   const cells = props.products.map((product, index) => {
//     return <BarcodeCard product={product} />;
//   });

//   return <>{cells}</>;
// }

import React from "react";
import BarcodeCard from "./barcodeCard";
import BarcodeCardThree from "./barcodeCardThree";
import BarcodeCardA4 from "./barcodeCardA4";

export default function Page(props) {
  const { products, selectedDesign } = props;

  const renderBarcodeCard = (product) => {
    if (selectedDesign === "2by1") {
      return <BarcodeCard key={product.id} product={product} />;
    } else if (selectedDesign === "3by1") {
      return <BarcodeCardThree key={product.id} product={product} />;
    } else if (selectedDesign === "4by1") {
      return <BarcodeCardA4 key={product.id} product={product} />;
    }
    return null;
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", width: "8.27in", justifyContent:"space-between"}}>
      {products.map((product, index) => renderBarcodeCard(product))}
    </div>
  );
}


